module.exports = __webpack_public_path__ + "img/doggo1.b2f825f5.jpg";